// @flow

import gql from 'graphql-tag';

import { useQuery } from '@apollo/react-hooks';

import type { OperationVariables } from '@apollo/react-common';

export type Account = {
  id: number,
  normalizedImageUrl: string,
  normalizedName: string,
};

export type AccountsResponse = {
  accounts: Array<Account>,
  currentUserV2: {
    id: string,
    email: string,
  },
};

type Result = {
  ...$Exact<OperationVariables>,
  data: AccountsResponse,
};

export const accountsDataQuery = gql`
  query accountsDataQuery {
    accounts {
      id
      normalizedImageUrl
      normalizedName
    }
    currentUserV2 {
      id
      email
    }
  }
`;

/**
 * Hook that provides data used for the accounts menu inside global navigation.
 */
const useAccountsMenuData = (): Result =>
  useQuery(accountsDataQuery, { ssr: false });

export default useAccountsMenuData;
